import { PaletteMode } from "@mui/material";
import { noop } from "lodash";
import { createContext } from "react";

export const PaletteModeContext = createContext<{
  paletteMode: PaletteMode;
  setPaletteMode: (newMode: PaletteMode) => void;
}>({ paletteMode: "light", setPaletteMode: noop });
